/**
 * Invitation code from BE/email: 8 alphanumeric characters (e.g. DT38QZ10).
 * API sends the flat normalized string (mobile invitation parity).
 */
export const INVITATION_CODE_SEGMENT_LENGTH = 4
export const INVITATION_CODE_SEGMENT_COUNT = 2
export const INVITATION_CODE_MAX_LENGTH =
  INVITATION_CODE_SEGMENT_LENGTH * INVITATION_CODE_SEGMENT_COUNT

const INVITATION_CODE_INPUT_ALLOWED_KEYS = new Set([
  'Backspace',
  'Delete',
  'Tab',
  'Escape',
  'Enter',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  'Home',
  'End',
])

export function shouldAllowInvitationCodeKeydown(event) {
  if (!event || typeof event.key !== 'string') {
    return true
  }

  if (event.ctrlKey || event.metaKey || event.altKey) {
    return true
  }

  if (INVITATION_CODE_INPUT_ALLOWED_KEYS.has(event.key)) {
    return true
  }

  if (event.key.length !== 1) {
    return true
  }

  return /[a-zA-Z0-9]/.test(event.key)
}

export function formatInvitationCodeInput(value) {
  if (!value) {
    return ''
  }

  return String(value)
    .toUpperCase()
    .replace(/[^a-zA-Z0-9]/g, '')
    .slice(0, INVITATION_CODE_MAX_LENGTH)
}

export function splitInvitationCodeSegments(value) {
  const formatted = formatInvitationCodeInput(value)

  return Array.from({ length: INVITATION_CODE_SEGMENT_COUNT }, function (_, index) {
    const start = index * INVITATION_CODE_SEGMENT_LENGTH
    const end = start + INVITATION_CODE_SEGMENT_LENGTH

    return formatted.slice(start, end)
  })
}

export function formatInvitationCodeForApi(value) {
  return formatInvitationCodeInput(value)
}

export function isInvitationCodeComplete(value) {
  return formatInvitationCodeInput(value).length === INVITATION_CODE_MAX_LENGTH
}
